export default __webpack_public_path__ + "static/media/cover.2abf4d04.png";